<template lang="pug">
.map-offcanvas__item
  .map-offcanvas__title
    span(uk-icon="icon: location; ratio: .7")
    div &nbsp;表示切替

  .map-offcanvas__body
    .uk-padding-small.uk-padding-remove-vertical
      .uk-margin-xsmall
        label.uk-form-label
          input.uk-checkbox.uk-border-rounded(
            type="checkbox",
            v-model="all_hazard_layers_is_show"
          )
          | &nbsp;洪水浸水想定区域 (全て)

      .uk-margin-xsmall.uk-text-small.uk-padding-small.uk-background-muted
        div 複数の河川の浸水想定区域が重なる地点では深さを示す色が濃く表示されます。
        div その場合、河川ごとに表示し確認してください。
        hr
        //- .uk-margin-small
        //-   label.uk-form-label
        //-     input.uk-checkbox.uk-border-rounded(
        //-       type="checkbox",
        //-       v-model="hazard_layer_is_show"
        //-     )
        //-     | &nbsp;雄物川・皆瀬川・成瀬川・横手川

        .uk-margin-small
          label.uk-form-label
            input.uk-checkbox.uk-border-rounded(
              type="checkbox",
              v-model="hazard_extends_minase_naruse_omonogawa_layer_is_show"
            )
            | &nbsp;雄物川・皆瀬川・成瀬川

        .uk-margin-small(style="margin-left: 1rem")
          label.uk-form-label
            input.uk-checkbox.uk-border-rounded(
              type="checkbox",
              v-model="hazard_extends_minase_naruse_omonogawa_soukihinan_layer_is_show"
            )
            | &nbsp;早期避難が必要な区域

        .uk-margin-small
          label.uk-form-label
            input.uk-checkbox.uk-border-rounded(
              type="checkbox",
              v-model="hazard_extends_minasegawa_layer_is_show"
            )
            |&nbsp;皆瀬川上流域(増田)

        .uk-margin-small
          label.uk-form-label
            input.uk-checkbox.uk-border-rounded(
              type="checkbox",
              v-model="hazard_extends_narusegawa_layer_is_show"
            )
            | &nbsp;成瀬川上流域(増田)

        .uk-margin-small
          label.uk-form-label
            input.uk-checkbox.uk-border-rounded(
              type="checkbox",
              v-model="hazard_extends_yokotegawa_layer_is_show"
            )
            |&nbsp;横手川

        .uk-margin-small(style="margin-left: 1rem")
          label.uk-form-label
            input.uk-checkbox.uk-border-rounded(
              type="checkbox",
              v-model="hazard_extends_yokotegawa_soukihinan_layer_is_show"
            )
            |&nbsp;早期避難が必要な区域

        .uk-margin-small
          label.uk-form-label
            input.uk-checkbox.uk-border-rounded(
              type="checkbox",
              v-model="hazard_extends_yokotegawasannai_layer_is_show"
            )
            | &nbsp;横手川上流域(山内)

        .uk-margin-small
          label.uk-form-label
            input.uk-checkbox.uk-border-rounded(
              type="checkbox",
              v-model="hazard_extends_ootogawa_layer_is_show"
            )
            | &nbsp;大戸川(横手)

        .uk-margin-small
          label.uk-form-label
            input.uk-checkbox.uk-border-rounded(
              type="checkbox",
              v-model="hazard_extends_kashiranashigawa_layer_is_show"
            )
            | &nbsp;頭無川(横手)

        .uk-margin-small
          label.uk-form-label
            input.uk-checkbox.uk-border-rounded(
              type="checkbox",
              v-model="hazard_extends_saragawa_layer_is_show"
            )
            | &nbsp;皿川(横手)

        .uk-margin-small
          label.uk-form-label
            input.uk-checkbox.uk-border-rounded(
              type="checkbox",
              v-model="hazard_extends_sugisawagawa_layer_is_show"
            )
            | &nbsp;横手杉沢川(横手)

        .uk-margin-small
          label.uk-form-label
            input.uk-checkbox.uk-border-rounded(
              type="checkbox",
              v-model="hazard_extends_kuriyagawa_layer_is_show"
            )
            | &nbsp;厨川(横手)

        .uk-margin-small
          label.uk-form-label
            input.uk-checkbox.uk-border-rounded(
              type="checkbox",
              v-model="hazard_extends_nakanomekawa_layer_is_show"
            )
            | &nbsp;中ノ目川(横手)

        .uk-margin-small
          label.uk-form-label
            input.uk-checkbox.uk-border-rounded(
              type="checkbox",
              v-model="hazard_extends_uwamizo_layer_is_show"
            )
            | &nbsp;上溝川(大森)

        .uk-margin-small
          label.uk-form-label
            input.uk-checkbox.uk-border-rounded(
              type="checkbox",
              v-model="hazard_extends_imokawa_layer_is_show"
            )
            | &nbsp;芋川(大森)

        .uk-margin-small
          label.uk-form-label
            input.uk-checkbox.uk-border-rounded(
              type="checkbox",
              v-model="hazard_extends_sakabegawa_layer_is_show"
            )
            | &nbsp;坂部川(大森)

        .uk-margin-small
          label.uk-form-label
            input.uk-checkbox.uk-border-rounded(
              type="checkbox",
              v-model="hazard_extends_naraokagawa_layer_is_show"
            )
            | &nbsp;楢岡川(大森)

        .uk-margin-small
          label.uk-form-label
            input.uk-checkbox.uk-border-rounded(
              type="checkbox",
              v-model="hazard_extends_shirakogawa_layer_is_show"
            )
            | &nbsp;白子川(十文字)

        .uk-margin-small
          label.uk-form-label
            input.uk-checkbox.uk-border-rounded(
              type="checkbox",
              v-model="hazard_extends_ugoootogawa_layer_is_show"
            )
            | &nbsp;羽後大戸川(十文字)

        .uk-margin-small
          label.uk-form-label
            input.uk-checkbox.uk-border-rounded(
              type="checkbox",
              v-model="hazard_extends_kurosawagawa_layer_is_show"
            )
            | &nbsp;山内黒沢川(山内)

        .uk-margin-small
          label.uk-form-label
            input.uk-checkbox.uk-border-rounded(
              type="checkbox",
              v-model="hazard_extends_matsukawa_layer_is_show"
            )
            | &nbsp;松川(山内)

        .uk-margin-small
          label.uk-form-label
            input.uk-checkbox.uk-border-rounded(
              type="checkbox",
              v-model="hazard_extends_iwanomesawa_layer_is_show"
            )
            | &nbsp;岩の目沢川(山内)

        .uk-margin-small
          label.uk-form-label
            input.uk-checkbox.uk-border-rounded(
              type="checkbox",
              v-model="hazard_extends_budougawa_layer_is_show"
            )
            | &nbsp;武道川(山内)

      .uk-margin-small
        label.uk-form-label
          input.uk-checkbox.uk-border-rounded(
            type="checkbox",
            v-model="tameike_layers_is_show"
          )
          | &nbsp;ため池決壊時浸水想定区域

      .uk-margin-small
        label.uk-form-label
          input.uk-checkbox.uk-border-rounded(
            type="checkbox",
            v-model="sediment_layers_is_show",
          )
          | &nbsp;土砂災害警戒区域等

      .uk-margin-small
        label.uk-form-label
          input.uk-checkbox.uk-border-rounded(
            type="checkbox",
            v-model="ekijyoka_layer_is_show",
          )
          | &nbsp;液状化ハザードマップ

      .uk-margin-small
        label.uk-form-label
          input.uk-checkbox.uk-border-rounded(
            type="checkbox",
            v-model="custom_layers_is_show",
          )
          | &nbsp;通行止め等

      .uk-margin-small
        label.uk-form-label
          input.uk-checkbox.uk-border-rounded(
            type="checkbox",
            v-model="shelter_markers_is_show",
          )
          | &nbsp;開設中の避難所

      .uk-margin-small
        label.uk-form-label
          input.uk-checkbox.uk-border-rounded(
            type="checkbox",
            v-model="closed_shelter_markers_is_show",
          )
          | &nbsp;全ての避難所

      .uk-margin-small
        label.uk-form-label
          input.uk-checkbox.uk-border-rounded(
            type="checkbox",
            v-model="kikikuru_layer_is_show",
          )
          | &nbsp;キキクル(危険度分布)

      .uk-margin-small(v-if="is_winter")
        label.uk-form-label
          input.uk-checkbox.uk-border-rounded(
            type="checkbox",
            v-model="snowd_layer_is_show",
          )
          | &nbsp;今後の雪(6時間降雪短時間予想)

      .uk-margin-small(v-else)
        label.uk-form-label
          input.uk-checkbox.uk-border-rounded(
            type="checkbox",
            v-model="raind_layer_is_show",
          )
          | &nbsp;今後の雨(3時間降水短時間予想)

</template>

<script>
import * as types from '../js/mutations/map-mutations';
export default {
  computed: {
    is_winter() {
      return this.$store.getters.is_winter;
    },
    /**
     * 気象庁データ
     */
    // hazard_layer_is_show: {
    //   get() {
    //     return this.$store.getters.hazard_layer_is_show;
    //   },
    //   set(value) {
    //     this.$store.dispatch(types.TOGGLE_LAYER, { layer_name: 'hazard_layer', state: value });
    //   },
    // },

    /**
     * 全レイヤー
     */
    all_hazard_layers_is_show: {
      get() {
        return this.$store.getters.all_hazard_layers_is_show;
      },
      set(value) {
        this.$store.dispatch(types.VISIBLE_SETTINGS_BY_USER, {
          layer_name: 'hazard_layer',
          state: value,
        });
        /**
         * 国土地理院
         */
        // this.$store.dispatch(types.TOGGLE_LAYER, { layer_name: 'hazard_layer', state: value });

        /**
         * 拡張レイヤー
         */
        this.$store.dispatch(types.TOGGLE_LAYER, {
          layer_name: 'hazard_extends_all_layers',
          state: value,
        });
        this.$store.dispatch(types.TOGGLE_LAYER, {
          layer_name: 'hazard_extends_minase_naruse_omonogawa_layer',
          state: value,
        });
        this.$store.dispatch(types.TOGGLE_LAYER, {
          layer_name: 'hazard_extends_minase_naruse_omonogawa_soukihinan_layer',
          state: value,
        });
        this.$store.dispatch(types.TOGGLE_LAYER, {
          layer_name: 'hazard_extends_yokotegawa_layer',
          state: value,
        });
        this.$store.dispatch(types.TOGGLE_LAYER, {
          layer_name: 'hazard_extends_yokotegawa_soukihinan_layer',
          state: value,
        });
        this.$store.dispatch(types.TOGGLE_LAYER, {
          layer_name: 'hazard_extends_uwamizo_layer',
          state: value,
        });
        this.$store.dispatch(types.TOGGLE_LAYER, {
          layer_name: 'hazard_extends_saragawa_layer',
          state: value,
        });
        this.$store.dispatch(types.TOGGLE_LAYER, {
          layer_name: 'hazard_extends_ootogawa_layer',
          state: value,
        });
        this.$store.dispatch(types.TOGGLE_LAYER, {
          layer_name: 'hazard_extends_kashiranashigawa_layer',
          state: value,
        });
        this.$store.dispatch(types.TOGGLE_LAYER, {
          layer_name: 'hazard_extends_budougawa_layer',
          state: value,
        });
        this.$store.dispatch(types.TOGGLE_LAYER, {
          layer_name: 'hazard_extends_iwanomesawa_layer',
          state: value,
        });
        this.$store.dispatch(types.TOGGLE_LAYER, {
          layer_name: 'hazard_extends_kuriyagawa_layer',
          state: value,
        });
        this.$store.dispatch(types.TOGGLE_LAYER, {
          layer_name: 'hazard_extends_kurosawagawa_layer',
          state: value,
        });
        this.$store.dispatch(types.TOGGLE_LAYER, {
          layer_name: 'hazard_extends_matsukawa_layer',
          state: value,
        });
        this.$store.dispatch(types.TOGGLE_LAYER, {
          layer_name: 'hazard_extends_minasegawa_layer',
          state: value,
        });
        this.$store.dispatch(types.TOGGLE_LAYER, {
          layer_name: 'hazard_extends_naraokagawa_layer',
          state: value,
        });
        this.$store.dispatch(types.TOGGLE_LAYER, {
          layer_name: 'hazard_extends_narusegawa_layer',
          state: value,
        });
        this.$store.dispatch(types.TOGGLE_LAYER, {
          layer_name: 'hazard_extends_sakabegawa_layer',
          state: value,
        });
        this.$store.dispatch(types.TOGGLE_LAYER, {
          layer_name: 'hazard_extends_shirakogawa_layer',
          state: value,
        });
        this.$store.dispatch(types.TOGGLE_LAYER, {
          layer_name: 'hazard_extends_sugisawagawa_layer',
          state: value,
        });
        this.$store.dispatch(types.TOGGLE_LAYER, {
          layer_name: 'hazard_extends_ugoootogawa_layer',
          state: value,
        });
        this.$store.dispatch(types.TOGGLE_LAYER, {
          layer_name: 'hazard_extends_yokotegawasannai_layer',
          state: value,
        });
        this.$store.dispatch(types.TOGGLE_LAYER, {
          layer_name: 'hazard_extends_nakanomekawa_layer',
          state: value,
        });
        this.$store.dispatch(types.TOGGLE_LAYER, {
          layer_name: 'hazard_extends_imokawa_layer',
          state: value,
        });
      },
    },
    hazard_extends_minase_naruse_omonogawa_layer_is_show: {
      get() {
        return this.$store.getters.hazard_extends_minase_naruse_omonogawa_layer_is_show;
      },
      set(value) {
        this.$store.dispatch(types.TOGGLE_LAYER, {
          layer_name: 'hazard_extends_minase_naruse_omonogawa_layer',
          state: value,
        });
        this.$store.dispatch(types.TOGGLE_LAYER, {
          layer_name: 'hazard_extends_minase_naruse_omonogawa_soukihinan_layer',
          state: value,
        });
      },
    },
    hazard_extends_minase_naruse_omonogawa_soukihinan_layer_is_show: {
      get() {
        return this.$store.getters.hazard_extends_minase_naruse_omonogawa_soukihinan_layer_is_show;
      },
      set(value) {
        this.$store.dispatch(types.TOGGLE_LAYER, {
          layer_name: 'hazard_extends_minase_naruse_omonogawa_layer',
          state: value,
        });
        this.$store.dispatch(types.TOGGLE_LAYER, {
          layer_name: 'hazard_extends_minase_naruse_omonogawa_soukihinan_layer',
          state: value,
        });
      },
    },
    hazard_extends_yokotegawa_layer_is_show: {
      get() {
        return this.$store.getters.hazard_extends_yokotegawa_layer_is_show;
      },
      set(value) {
        this.$store.dispatch(types.TOGGLE_LAYER, {
          layer_name: 'hazard_extends_yokotegawa_layer',
          state: value,
        });
        this.$store.dispatch(types.TOGGLE_LAYER, {
          layer_name: 'hazard_extends_yokotegawa_soukihinan_layer',
          state: value,
        });
      },
    },
    hazard_extends_yokotegawa_soukihinan_layer_is_show: {
      get() {
        return this.$store.getters.hazard_extends_yokotegawa_soukihinan_layer_is_show;
      },
      set(value) {
        this.$store.dispatch(types.TOGGLE_LAYER, {
          layer_name: 'hazard_extends_yokotegawa_layer',
          state: value,
        });
        this.$store.dispatch(types.TOGGLE_LAYER, {
          layer_name: 'hazard_extends_yokotegawa_soukihinan_layer',
          state: value,
        });
      },
    },
    hazard_extends_uwamizo_layer_is_show: {
      get() {
        return this.$store.getters.hazard_extends_uwamizo_layer_is_show;
      },
      set(value) {
        this.$store.dispatch(types.TOGGLE_LAYER, {
          layer_name: 'hazard_extends_uwamizo_layer',
          state: value,
        });
      },
    },
    hazard_extends_saragawa_layer_is_show: {
      get() {
        return this.$store.getters.hazard_extends_saragawa_layer_is_show;
      },
      set(value) {
        this.$store.dispatch(types.TOGGLE_LAYER, {
          layer_name: 'hazard_extends_saragawa_layer',
          state: value,
        });
      },
    },
    hazard_extends_ootogawa_layer_is_show: {
      get() {
        return this.$store.getters.hazard_extends_ootogawa_layer_is_show;
      },
      set(value) {
        this.$store.dispatch(types.TOGGLE_LAYER, {
          layer_name: 'hazard_extends_ootogawa_layer',
          state: value,
        });
      },
    },
    hazard_extends_kashiranashigawa_layer_is_show: {
      get() {
        return this.$store.getters.hazard_extends_kashiranashigawa_layer_is_show;
      },
      set(value) {
        this.$store.dispatch(types.TOGGLE_LAYER, {
          layer_name: 'hazard_extends_kashiranashigawa_layer',
          state: value,
        });
      },
    },
    hazard_extends_budougawa_layer_is_show: {
      get() {
        return this.$store.getters.hazard_extends_budougawa_layer_is_show;
      },
      set(value) {
        this.$store.dispatch(types.TOGGLE_LAYER, {
          layer_name: 'hazard_extends_budougawa_layer',
          state: value,
        });
      },
    },
    hazard_extends_iwanomesawa_layer_is_show: {
      get() {
        return this.$store.getters.hazard_extends_iwanomesawa_layer_is_show;
      },
      set(value) {
        this.$store.dispatch(types.TOGGLE_LAYER, {
          layer_name: 'hazard_extends_iwanomesawa_layer',
          state: value,
        });
      },
    },
    hazard_extends_kuriyagawa_layer_is_show: {
      get() {
        return this.$store.getters.hazard_extends_kuriyagawa_layer_is_show;
      },
      set(value) {
        this.$store.dispatch(types.TOGGLE_LAYER, {
          layer_name: 'hazard_extends_kuriyagawa_layer',
          state: value,
        });
      },
    },
    hazard_extends_kurosawagawa_layer_is_show: {
      get() {
        return this.$store.getters.hazard_extends_kurosawagawa_layer_is_show;
      },
      set(value) {
        this.$store.dispatch(types.TOGGLE_LAYER, {
          layer_name: 'hazard_extends_kurosawagawa_layer',
          state: value,
        });
      },
    },
    hazard_extends_matsukawa_layer_is_show: {
      get() {
        return this.$store.getters.hazard_extends_matsukawa_layer_is_show;
      },
      set(value) {
        this.$store.dispatch(types.TOGGLE_LAYER, {
          layer_name: 'hazard_extends_matsukawa_layer',
          state: value,
        });
      },
    },
    hazard_extends_minasegawa_layer_is_show: {
      get() {
        return this.$store.getters.hazard_extends_minasegawa_layer_is_show;
      },
      set(value) {
        this.$store.dispatch(types.TOGGLE_LAYER, {
          layer_name: 'hazard_extends_minasegawa_layer',
          state: value,
        });
      },
    },
    hazard_extends_naraokagawa_layer_is_show: {
      get() {
        return this.$store.getters.hazard_extends_naraokagawa_layer_is_show;
      },
      set(value) {
        this.$store.dispatch(types.TOGGLE_LAYER, {
          layer_name: 'hazard_extends_naraokagawa_layer',
          state: value,
        });
      },
    },
    hazard_extends_narusegawa_layer_is_show: {
      get() {
        return this.$store.getters.hazard_extends_narusegawa_layer_is_show;
      },
      set(value) {
        this.$store.dispatch(types.TOGGLE_LAYER, {
          layer_name: 'hazard_extends_narusegawa_layer',
          state: value,
        });
      },
    },
    hazard_extends_sakabegawa_layer_is_show: {
      get() {
        return this.$store.getters.hazard_extends_sakabegawa_layer_is_show;
      },
      set(value) {
        this.$store.dispatch(types.TOGGLE_LAYER, {
          layer_name: 'hazard_extends_sakabegawa_layer',
          state: value,
        });
      },
    },
    hazard_extends_shirakogawa_layer_is_show: {
      get() {
        return this.$store.getters.hazard_extends_shirakogawa_layer_is_show;
      },
      set(value) {
        this.$store.dispatch(types.TOGGLE_LAYER, {
          layer_name: 'hazard_extends_shirakogawa_layer',
          state: value,
        });
      },
    },
    hazard_extends_sugisawagawa_layer_is_show: {
      get() {
        return this.$store.getters.hazard_extends_sugisawagawa_layer_is_show;
      },
      set(value) {
        this.$store.dispatch(types.TOGGLE_LAYER, {
          layer_name: 'hazard_extends_sugisawagawa_layer',
          state: value,
        });
      },
    },
    hazard_extends_ugoootogawa_layer_is_show: {
      get() {
        return this.$store.getters.hazard_extends_ugoootogawa_layer_is_show;
      },
      set(value) {
        this.$store.dispatch(types.TOGGLE_LAYER, {
          layer_name: 'hazard_extends_ugoootogawa_layer',
          state: value,
        });
      },
    },
    hazard_extends_yokotegawasannai_layer_is_show: {
      get() {
        return this.$store.getters.hazard_extends_yokotegawasannai_layer_is_show;
      },
      set(value) {
        this.$store.dispatch(types.TOGGLE_LAYER, {
          layer_name: 'hazard_extends_yokotegawasannai_layer',
          state: value,
        });
      },
    },
    hazard_extends_nakanomekawa_layer_is_show: {
      get() {
        return this.$store.getters.hazard_extends_nakanomekawa_layer_is_show;
      },
      set(value) {
        this.$store.dispatch(types.TOGGLE_LAYER, {
          layer_name: 'hazard_extends_nakanomekawa_layer',
          state: value,
        });
      },
    },
    hazard_extends_imokawa_layer_is_show: {
      get() {
        return this.$store.getters.hazard_extends_imokawa_layer_is_show;
      },
      set(value) {
        this.$store.dispatch(types.TOGGLE_LAYER, {
          layer_name: 'hazard_extends_imokawa_layer',
          state: value,
        });
      },
    },

    tameike_layers_is_show: {
      get() {
        return this.$store.getters.tameike_layers_is_show;
      },
      set(value) {
        this.$store.dispatch(types.TOGGLE_LAYER, { layer_name: 'tameike_layers', state: value });
      },
    },
    sediment_layers_is_show: {
      get() {
        return this.$store.getters.sediment_layers_is_show;
      },
      set(value) {
        this.$store.dispatch(types.TOGGLE_LAYER, { layer_name: 'sediment_layers', state: value });
      },
    },
    custom_layers_is_show: {
      get() {
        return this.$store.getters.custom_layers_is_show;
      },
      set(value) {
        this.$store.dispatch(types.TOGGLE_LAYER, { layer_name: 'custom_layers', state: value });
      },
    },
    shelter_markers_is_show: {
      get() {
        return this.$store.getters.shelter_markers_is_show;
      },
      set(value) {
        this.$store.dispatch(types.TOGGLE_LAYER, { layer_name: 'shelter_markers', state: value });
      },
    },
    closed_shelter_markers_is_show: {
      get() {
        return this.$store.getters.closed_shelter_markers_is_show;
      },
      set(value) {
        this.$store.dispatch(types.TOGGLE_LAYER, {
          layer_name: 'closed_shelter_markers',
          state: value,
        });
      },
    },
    kikikuru_layer_is_show: {
      get() {
        return this.$store.getters.kikikuru_layer_is_show;
      },
      set(value) {
        this.$store.dispatch(types.TOGGLE_LAYER, { layer_name: 'kikikuru_layer', state: value });
      },
    },
    ekijyoka_layer_is_show: {
      get() {
        return this.$store.getters.ekijyoka_layer_is_show;
      },
      set(value) {
        this.$store.dispatch(types.TOGGLE_LAYER, { layer_name: 'ekijyoka_layer', state: value });
      },
    },
    snowd_layer_is_show: {
      get() {
        return this.$store.getters.snowd_layer_is_show;
      },
      set(value) {
        this.$store.dispatch(types.TOGGLE_LAYER, { layer_name: 'snowd_layer', state: value });
      },
    },
    raind_layer_is_show: {
      get() {
        return this.$store.getters.raind_layer_is_show;
      },
      set(value) {
        this.$store.dispatch(types.TOGGLE_LAYER, { layer_name: 'raind_layer', state: value });
      },
    },
  },
};
</script>
